import { usePostHog } from 'posthog-js/react'
import { useCallback } from 'react'

export const usePostHogEntityAction = () => {
  const posthog = usePostHog()

  const capture = useCallback(
    (
      eventName: string,
      metadata?: Record<string, string | string[] | number | null | undefined>
    ) => {
      if (import.meta.env.MODE !== 'production' || !posthog) {
        return
      }

      posthog.capture(eventName, metadata)
    },
    [posthog]
  )

  return { capture }
}
